import React from 'react'
import { Button } from './Button'
import { FAIcon } from './FAIcon'
import styles from './CircleButton.less'
import { pt } from 'common-data/proptypehelpers'
import Tooltip from 'rc-tooltip'

export class CircleButton extends React.Component {
  static propTypes = {
    icon: pt.string,
    children: pt.any,
    size: pt.string,
    placement: pt.string,
    toolTip: pt.string,
    disabled: pt.bool,
    loading: pt.bool,
    hide: pt.bool
  }

  static defaultProps = {
    icon: 'check',
    size: ''
  }

  render () {
    const { 'data-tid': testId = '', icon, children, size, toolTip, placement, disabled, loading, hide, ...rest } = this.props

    if (hide === true) {
      return null
    }

    const button = <Button data-tid={testId} disabled={loading || disabled} {...rest} className={styles[`btn${size}`]}>{loading ? <i className='fas fa-spinner fa-spin'></i> : <FAIcon name={icon} />}</Button>

    const { color } = rest
    const overlayStyle = color || ''

    if (toolTip) {
      return (
        <Tooltip placement={placement} overlayClassName={overlayStyle} overlay={<span dangerouslySetInnerHTML={{ __html: loading ? 'Processing...' : toolTip }}></span>}>
          {button}
        </Tooltip>
      )
    } else {
      return button
    }
  }
}
